<div class="max-w-[300px] p-5 mx-auto flex flex-col justify-center items-center gap-1">
  <img src="assets/images/files.svg" alt="files" class="w-20">
  <h2 class="!m-0 font-semibold text-lg">{{ emptyTitle | concat | translate }}</h2>
  <div class="text-gray-500 leading-6 text-center">{{ emptyDescription | concat | translate }}</div>
  <button mat-flat-button color="primary" (click)="onAdd.emit()" *ngIf="showAddBtn">
    <mat-icon>add</mat-icon>
    {{btnTitle}}
  </button>
</div>
